/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'

class FileElement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      width: null,
    }
    this.spanText = React.createRef()
  }

  componentDidMount() {
    this.setState({
      width: this.spanText.current.offsetWidth + 50,
    })
  }

  renderIcon() {
    if (this.props.isFocus) {
      if (this.props.lockedFiles[this.props.item.path]) {
        return 'ri-file-lock-fill'
      }
      return 'ri-file-text-fill'
    }
    if (this.props.lockedFiles[this.props.item.path]) {
      return 'ri-file-lock-line'
    }
    return 'ri-file-text-line'
  }

  render() {
    const { item, isFocus } = this.props
    return (
      <li style={{ marginTop: 5, width: this.state.width }} className={isFocus ? 'uk-active' : ''}>
        <a
          type="button"
          role="button"
          onClick={() => {
            if (!this.props.loadingVersion) {
              this.props.getFile(item.path)
            }
          }}
        >
          <span className="uk-inline uk-flex uk-flex-row uk-flex-middle">
            <i
              style={{ fontSize: 18 }}
              uk-tooltip={this.props.lockedFiles[item.path] ? 'Read-only' : null}
              className={`uk-margin-small-right ${this.renderIcon()}`}
            />
            <span
              ref={this.spanText}
              style={{ whiteSpace: 'nowrap' }}
            >
              {item.name}
            </span>
          </span>
        </a>
      </li>
    )
  }
}

export default FileElement
